export default {
  SET_INFOR_ORDER (state, newVal) {
    state.inforOrder = newVal
  },

  SET_ORDER_NO (state, newVal) {
    state.orderNo = newVal
  },

  SET_INFOR_MERCHANT (state, newVal) {
    state.inforMerchant = newVal
  }
}
